/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import moment from 'moment';
import { getType } from 'typesafe-actions';
import { AppAction } from '..';
import { Coop } from '../../db/stores/coops';
import { signOutAction } from '../session';
import { getCoops } from './actions';

export type CoopMap = { [facilityid: string]: Coop };

export interface CoopsState {
  items: CoopMap;
  fetching: boolean;
  lastFetch?: string | null;
  error?: Error;
}

export const coopsReducer: (state: CoopsState | undefined, action: AppAction) => CoopsState = (
  state: CoopsState = {
    fetching: false,
    items: {},
  },
  action
) => {
  switch (action.type) {
    case getType(getCoops.request):
      return {
        ...state,
        fetching: true,
      };
    case getType(getCoops.success):
      const newItems = action.payload.reduce((acc: CoopMap, curr: Coop) => {
        acc[curr.id] = curr;
        return acc;
      }, {} as CoopMap);

      return {
        items: {...state.items, ...newItems},
        fetching: false,
        lastFetch: moment().toISOString(),
      };
    case getType(signOutAction): {
      return {
        fetching: false,
        items: {},
      };
    }
  }

  return state;
};
